import { Component, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { environment } from '../../environments/environment';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  standalone: true,
  imports: [NgClass, RouterLink, RouterLinkActive, BsDropdownModule],
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements  OnInit {
  isExpanded = false;
  public env: string = '';
  public isAdmin: boolean = false;
  public isReader: boolean = false;
  public hasAISearchAccess: boolean = false;
  public isCollapsed: boolean = true;

  constructor(private msalService: MsalService, private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.env = environment.env;
   
    this.authService.getRoles().subscribe({
      next: (roles) => {
        this.isAdmin = roles.includes('ItemRegistry.Admin');
        this.isReader = roles.includes('ItemRegistry.Read');
        this.hasAISearchAccess = roles.includes('ItemRegistry.AISearch');
      },
      error: (error) => {
        console.error('Error loading roles:', error);
        this.isAdmin = false;
        this.isReader = false;
        this.hasAISearchAccess = false;
      }
    });
  }

  collapse() {
    this.removeFocus();
    this.isExpanded = false;
  }

  toggle() {
    this.removeFocus();
    this.isExpanded = !this.isExpanded;
  }

  public removeFocus() {
    // Remove focus from any active element to prevent aria-hidden warning
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  navigateAndCollapse(route: string) {
    this.collapse();
    this.router.navigate([route]);
  }

  // onHidden(): void {
  //   console.log('Dropdown is hidden');
  // }
  // onShown(): void {
  //   console.log('Dropdown is shown');
  // }
  // isOpenChange(): void {
  //   console.log('Dropdown state is changed');
  // }
}
